import { Card, CardBody } from '@/components/ui/Card';
import { useViewerStore } from '@/state/viewerStore';

export function LoadOverlay() {
  const load = useViewerStore((s) => s.load);
  if (!load.isLoading) return null;

  return (
    <div className="absolute inset-0 z-30 grid place-items-center bg-black/35">
      <Card className="min-w-[260px]">
        <CardBody>
          <div className="mb-3 text-foreground">{load.message}</div>
          <div className="h-1.5 w-full overflow-hidden rounded bg-white/10">
            <div
              className="h-full bg-accent transition-[width] duration-150 ease-out"
              style={{ width: `${load.percent}%` }}
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
